import { render, staticRenderFns } from "./UiGoogleButton.vue?vue&type=template&id=028f0a68&"
import script from "./UiGoogleButton.vue?vue&type=script&lang=js&"
export * from "./UiGoogleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports